import {Component, forwardRef, Injector, Input, ViewChild} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";
import {FormGroup} from "@angular/forms";
import {FUITimeControlComponent} from "@fedeltapointofsale/ui";

/**
 * Search grid column to render Date values
 */
@Component({
    selector: "wbo-date-column",
    styleUrls: ["./date-column.component.scss"],
    templateUrl: "./date-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => DateColumnComponent), multi: true}
    ]
})
export class DateColumnComponent extends AbstractColumnComponent {
    @Input() pattern: string;
    @Input() defaultValue: string;
    @Input() cellClassGetter: (this: void, formGroup: FormGroup, dataItem: any) => any;
    @ViewChild("editControl") editControl: FUITimeControlComponent;

    constructor(injector: Injector) {
        super(injector);
    }

    valueChanged(value: any, dataItem: any, formGroup: FormGroup, fieldName?: string): void {
        if (value == undefined && this.defaultValue) {
            this.editControl.value = this.defaultValue;
        } else {
            this.emitValueChange(value, dataItem, formGroup, fieldName);
        }
    }
}
